<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(880px, calc(100vw - 24px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.processId" class="title-actions">
        <el-button v-if="isAuth('base:process:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:process:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" class="process-form" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="工序编码" prop="processCode">
            <el-input v-model="form.processCode" :disabled="readonly" placeholder="工序编码" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工序名称" prop="processName">
            <el-input v-model="form.processName" :disabled="readonly" placeholder="工序名称" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所属车间" prop="workShopId">
            <el-select v-model="form.workShopId" :disabled="readonly" placeholder="请选择车间" style="width:100%" @change="onWorkShopChange">
              <el-option v-for="item in shops" :key="item.workShopId" :label="item.workShopName" :value="item.workShopId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="默认机台" prop="defaultWorkCenterId">
            <el-select v-model="form.defaultWorkCenterId" :disabled="readonly || !form.workShopId" clearable filterable placeholder="可选，APS自动排程优先" style="width:100%">
              <el-option v-for="item in shopCenters" :key="item.workCenterId" :label="centerLabel(item)" :value="item.workCenterId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="换模(时)" prop="setupHours">
            <el-input v-model="form.setupHours" :disabled="readonly" placeholder="同机台换工序占用" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="并行组" prop="parallelGroup">
            <el-input-number v-model="form.parallelGroup" :disabled="readonly" :min="0" :precision="0" controls-position="right" style="width:100%" placeholder=">0同组并行" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="操作员" prop="chargerList">
            <el-select v-model="chargerIds" :disabled="readonly" multiple filterable placeholder="请选择操作员" style="width:100%">
              <el-option v-for="item in users" :key="item.id" :label="item.username" :value="String(item.id)" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上报人" prop="reportByList">
            <el-select v-model="reportIds" :disabled="readonly" multiple filterable placeholder="请选择上报人" style="width:100%">
              <el-option v-for="item in users" :key="'r' + item.id" :label="item.username" :value="String(item.id)" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="人数" prop="processNumber">
            <el-input v-model="form.processNumber" :disabled="readonly" placeholder="人数" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="节拍" prop="processBeat">
            <el-input v-model="form.processBeat" :disabled="readonly" placeholder="节拍" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="加工单价" prop="processPrice">
            <el-input v-model="form.processPrice" :disabled="readonly" placeholder="加工单价" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工时费" prop="laborCost">
            <el-input v-model="form.laborCost" :disabled="readonly" placeholder="工时费" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="委外工序" prop="isOutProcess">
            <el-radio-group v-model="form.isOutProcess" :disabled="readonly">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用状态" prop="isenabled">
            <el-radio-group v-model="form.isenabled" :disabled="readonly">
              <el-radio label="0">启用</el-radio>
              <el-radio label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="form.sort" :disabled="readonly" :min="0" :precision="0" controls-position="right" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" placeholder="备注" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

const decimalRule = (rule, value, callback) => {
  if (value === '' || value === null || value === undefined) callback()
  else if (!/^(\d+)(\.\d{1,2})?$/.test(value)) callback(new Error('请输入数字，最多保留两位小数'))
  else callback()
}

export default {
  data() {
    return {
      visible: false, readonly: false, form: {}, chargerIds: [], reportIds: [],
      shops: [], centers: [], users: [], permCodes: [],
      rules: {
        processCode: [{ required: true, message: '工序编码不能为空', trigger: 'blur' }],
        processName: [{ required: true, message: '工序名称不能为空', trigger: 'blur' }],
        workShopId: [{ required: true, message: '所属车间不能为空', trigger: 'change' }],
        processNumber: [{ validator: decimalRule, trigger: 'blur' }],
        processBeat: [{ validator: decimalRule, trigger: 'blur' }],
        setupHours: [{ validator: decimalRule, trigger: 'blur' }],
        processPrice: [{ validator: decimalRule, trigger: 'blur' }],
        laborCost: [{ validator: decimalRule, trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看工序'
      return this.form.processId ? '修改工序' : '新增工序'
    },
    shopCenters() {
      return this.centers
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.loadOptions()
      this.readonly = !!readonly
      this.chargerIds = []
      this.reportIds = []
      this.form = this.blankForm()
      this.visible = true
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      if (id) this.fetchDetail(id)
    },
    fetchDetail(id) {
      request.get('/base/process/info/' + id).then(res => {
        const row = res.data || {}
        row.processNumber = row.processNumber != null ? String(row.processNumber) : ''
        row.processBeat = row.processBeat != null ? String(row.processBeat) : ''
        row.processPrice = row.processPrice != null ? String(row.processPrice) : ''
        row.laborCost = row.laborCost != null ? String(row.laborCost) : ''
        row.setupHours = row.setupHours != null ? String(row.setupHours) : ''
        row.sort = row.sort || 0
        row.parallelGroup = row.parallelGroup == null || row.parallelGroup === '' ? null : Number(row.parallelGroup)
        this.form = Object.assign(this.blankForm(), row)
        this.chargerIds = this.splitIds(row.charger)
        this.reportIds = this.splitIds(row.reportBy)
        this.loadWorkCenterList(row.workShopId, true)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {})
    },
    loadOptions() {
      request.get('/base/workShop/selectEnabled').then(res => { this.shops = res.data || [] }).catch(() => {})
      request.get('/sys/users').then(res => { this.users = res.data || [] }).catch(() => {})
    },
    loadWorkCenterList(workShopId, keepDefault) {
      if (!workShopId) {
        this.centers = []
        if (!keepDefault) this.form.defaultWorkCenterId = ''
        return
      }
      request.get('/production/workCenter/selectEnabled', { params: { workShopId } }).then(res => {
        this.centers = res.data || []
        if (!keepDefault) {
          this.form.defaultWorkCenterId = ''
        } else if (this.form.defaultWorkCenterId) {
          const ok = this.centers.some(c => c.workCenterId === this.form.defaultWorkCenterId)
          if (!ok) this.form.defaultWorkCenterId = ''
        }
      }).catch(() => { this.centers = [] })
    },
    splitIds(value) {
      return value ? String(value).split(',').map(s => s.trim()).filter(Boolean) : []
    },
    centerLabel(item) {
      if (!item) return ''
      return item.workCenterCode ? (item.workCenterCode + ' ' + (item.workCenterName || '')).trim() : (item.workCenterName || '')
    },
    onWorkShopChange() {
      this.loadWorkCenterList(this.form.workShopId, false)
    },
    handleConcurrentConflict(msg) {
      const text = msg || '操作失败'
      if (text.indexOf('数据已被其他用户更新') === -1 || !this.form.processId) return
      this.$confirm('当前数据已被其他用户更新，是否重新加载最新数据？', '提示', {
        confirmButtonText: '重新加载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchDetail(this.form.processId)
      }).catch(() => {})
    },
    blankForm() {
      return {
        isenabled: '0', isOutProcess: '0', sort: 0, parallelGroup: null, defaultWorkCenterId: '',
        setupHours: '', processNumber: '', processBeat: '', processPrice: '', laborCost: '', remark: ''
      }
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const payload = {
          processId: this.form.processId || undefined,
          version: this.form.version,
          processCode: this.form.processCode,
          processName: this.form.processName,
          workShopId: this.form.workShopId,
          defaultWorkCenterId: this.form.defaultWorkCenterId || null,
          setupHours: this.form.setupHours || null,
          parallelGroup: this.form.parallelGroup,
          charger: (this.chargerIds || []).join(','),
          reportBy: (this.reportIds || []).join(','),
          processNumber: this.form.processNumber || null,
          processBeat: this.form.processBeat || null,
          processPrice: this.form.processPrice || null,
          laborCost: this.form.laborCost || null,
          remark: this.form.remark,
          sort: this.form.sort,
          isOutProcess: this.form.isOutProcess,
          isenabled: this.form.isenabled
        }
        request.post('/base/process/' + (payload.processId ? 'update' : 'save'), payload).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(err => { this.handleConcurrentConflict(err && err.message) })
      })
    },
    remove() {
      this.$confirm('确定删除该工序？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/process/delete', [this.form.processId]).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
@media (max-width: 800px) {
  .process-form >>> .el-col-12 { width: 100%; }
}
</style>
